import { render } from "./OfferTable.vue?vue&type=template&id=435bec64&scoped=true"
import script from "./OfferTable.vue?vue&type=script&lang=js"
export * from "./OfferTable.vue?vue&type=script&lang=js"

import "./OfferTable.vue?vue&type=style&index=0&id=435bec64&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435bec64"]])

export default __exports__